(() => {
  "use strict";

  (function injectSpinnerKillCss() {
    if (document.getElementById("yb-spinner-kill")) return;
    const style = document.createElement("style");
    style.id = "yb-spinner-kill";
    style.textContent =
      "html body.show_image_loading .adaptive_height img.lazyload+.data-lazy-loading," +
      "html body.show_image_loading .adaptive_height img.lazyloading+.data-lazy-loading," +
      "html body.show_image_loading .adaptive_height img.lazyloaded+.data-lazy-loading," +
      "html body.show_image_loading .media img.lazyload+.data-lazy-loading," +
      "html body.show_image_loading .media img.lazyloading+.data-lazy-loading," +
      "html body.show_image_loading .card-media img.lazyload+.data-lazy-loading," +
      "html body.show_image_loading .card-media img.lazyloading+.data-lazy-loading," +
      "html body .data-lazy-loading,.data-lazy-loading{display:none!important;visibility:hidden!important;" +
      "opacity:0!important;width:0!important;height:0!important;background:none!important;" +
      "animation:none!important;pointer-events:none!important}" +
      "body.show_image_loading img.lazyload,body.show_image_loading img.lazyloading," +
      "body.show_image_loading img.lazyloaded,.adaptive_height img,.media img," +
      ".card-media>img:first-child{opacity:1!important}" +
      "html body.show_image_loading .card-media>img+img,html body.show_image_loading .card-media>img+video," +
      "html body .card-media>img+img,html body .card-media>img+video{opacity:0!important}" +
      "html body .card-product:hover .card-media.media--hover-effect>img:first-child:not(:only-child){opacity:0!important}" +
      "html body .card-product:hover .card-media.media--hover-effect>img+img{opacity:1!important}" +
      "#yb-page-loader,.loadingOverlay{display:none!important}";
    (document.head || document.documentElement).appendChild(style);
  })();

  (function injectPartnerCtaCss() {
    if (document.getElementById("yb-partner-cta-compact")) return;
    const style = document.createElement("style");
    style.id = "yb-partner-cta-compact";
    style.textContent =
      ".yb-partner-footer-cta,a.yb-partner-footer-cta{display:inline-flex!important;flex-direction:row!important;" +
      "align-items:center!important;justify-content:center!important;gap:0!important;width:auto!important;" +
      "max-width:none!important;min-height:0!important;height:auto!important;margin:12px 0 0!important;" +
      "padding:6px 12px!important;border-radius:6px!important;border:1px solid #e6b000!important;" +
      "background:#ffc400!important;color:#0b1f3a!important;font-size:12px!important;font-weight:700!important;" +
      "letter-spacing:.02em!important;line-height:1.2!important;text-align:center!important;" +
      "text-decoration:none!important;white-space:nowrap!important;box-shadow:none!important;" +
      "align-self:flex-start!important}" +
      ".yb-partner-footer-cta__icon,.yb-partner-footer-cta svg{display:none!important}" +
      ".yb-partner-footer-cta__text{font-size:inherit!important;font-weight:inherit!important;color:inherit!important}";
    (document.head || document.documentElement).appendChild(style);
  })();

  const CHECKOUT_GUIDE_BUILD = "20260909ux8";
  if (window.YamBabaCheckoutGuide && window.YamBabaCheckoutGuideBuild === CHECKOUT_GUIDE_BUILD) return;
  if (window.YamBabaCheckoutGuide) {
    document.querySelector(".yb-guide-overlay")?.remove();
    document.body.classList.remove("yb-guide-lock");
    delete window.YamBabaCheckoutGuide;
  }

  const LOCATION_DISMISSED_KEY = "yambaba_location_prompt_dismissed";
  const CART_OPEN_SELECTOR = [
    "[data-cart-sidebar]",
    ".header__icon--cart",
    "a[href='/cart']",
    "a[href='/cart/']",
  ].join(",");
  const LEAFLET_VERSION = "1.9.4";
  const CHECKOUT_SELECTOR = [
    'a[href^="/checkout"]',
    'a[href*="/checkout?"]',
    'button[name="checkout"]',
    'input[name="checkout"]',
    "[data-cart-checkout]",
    ".previewCartGroup .button:first-child",
  ].join(",");
  const EXCLUDED_CHECKOUT_SELECTOR = [
    "shopify-accelerated-checkout",
    "shopify-accelerated-checkout-cart",
    ".shopify-payment-button",
    "[data-shopify-buttoncontainer]",
    "[data-testid*='ShopPay']",
    "[aria-label*='Shop Pay']",
    "[aria-label*='Buy it now']",
  ].join(",");
  const ACTION_HOST_SELECTOR = [
    ".scoder-cart-sidebar .previewCartGroup",
    ".scoder-cart-sidebar .cart__footer",
    "form[action*='/cart'] .cart__footer",
    ".cart__footer",
    ".cart__blocks",
  ].join(",");
  const ATTRIBUTES = {
    lat: "yambaba_delivery_lat",
    lng: "yambaba_delivery_lng",
    accuracy: "yambaba_delivery_accuracy",
    capturedAt: "yambaba_delivery_captured_at",
    source: "yambaba_delivery_source",
    mapUrl: "yambaba_delivery_map_url",
  };

  let activeModal = null;
  let activeMap = null;
  let lastFocused = null;
  let pendingCheckout = null;
  let locationConfirmed = false;
  let injectScheduled = false;
  let lastKnownCoords = null;
  let cartDrawerWasOpen = false;
  let locationPromptScheduled = false;
  function dismissLocationPrompt() {
    sessionStorage.setItem(LOCATION_DISMISSED_KEY, "1");
  }

  function shouldAutoPromptLocation() {
    return !locationConfirmed && sessionStorage.getItem(LOCATION_DISMISSED_KEY) !== "1";
  }

  function skipLocationPrompt() {
    if (!pendingCheckout) dismissLocationPrompt();
    continueCheckout();
  }

  const DUBAI_CENTER = [25.2048, 55.2708];

  function installStyles() {
    if (document.getElementById("yb-checkout-guide-styles")) return;
    const style = document.createElement("style");
    style.id = "yb-checkout-guide-styles";
    style.textContent = `
      .yb-guide-lock{overflow:hidden!important}
      .yb-guide-overlay{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(7,28,52,.68);backdrop-filter:blur(3px)}
      .yb-guide-modal{position:relative;width:min(620px,100%);max-height:min(760px,calc(100dvh - 40px));overflow:auto;border:1px solid rgba(18,104,179,.18);border-radius:22px;background:#fff;color:#17324d;box-shadow:0 24px 70px rgba(0,28,64,.3);font:400 16px/1.5 Arial,sans-serif}
      .yb-guide-head{padding:28px 64px 10px 28px}.yb-guide-head h2{margin:0;color:#0d5596;font-size:clamp(23px,4vw,31px);line-height:1.2}.yb-guide-head p{margin:9px 0 0;color:#50677e}
      .yb-guide-close{position:absolute;top:16px;right:16px;width:40px;height:40px;border:0;border-radius:50%;background:#edf5fc;color:#17324d;font-size:25px;line-height:1;cursor:pointer}.yb-guide-close:hover,.yb-guide-close:focus-visible{background:#ffcc24;outline:3px solid rgba(18,104,179,.25)}
      .yb-guide-body{padding:14px 28px 28px}.yb-guide-cards{display:grid;grid-template-columns:1fr 1fr;gap:14px}.yb-guide-card{padding:16px;border:2px solid #d7e5f2;border-radius:16px;background:#f8fbfe}.yb-guide-card--correct{border-color:#71acd9}.yb-guide-card--wrong{border-color:#e5b8b2;background:#fffafa}.yb-guide-card svg{display:block;width:72px;height:72px;margin-bottom:8px}.yb-guide-card strong{display:block;color:#123b67;font-size:18px}.yb-guide-card p{margin:5px 0 0;font-size:14px;color:#50677e}
      .yb-guide-fields{margin:10px 0 0;display:grid;gap:8px}.yb-guide-fields div{min-width:0}.yb-guide-fields dt{margin:0;color:#5a7085;font-size:11px;font-weight:700;letter-spacing:.01em}.yb-guide-fields dd{margin:1px 0 0;color:#123b67;font-size:14px;font-weight:600;line-height:1.35}.yb-guide-fields--wrong dd{color:#943a2e;font-weight:500}
      .yb-guide-note{margin:16px 0 0;padding:13px 15px;border-left:5px solid #ffcc24;border-radius:10px;background:#fff9df;color:#344b61;font-size:14px}
      .yb-guide-actions{display:flex;flex-wrap:wrap;justify-content:flex-end;gap:10px;margin-top:22px}.yb-guide-button{min-height:46px;padding:10px 18px;border:2px solid #1268b3;border-radius:999px;background:#1268b3;color:#fff;font:700 15px/1.2 Arial,sans-serif;cursor:pointer}.yb-guide-button:hover,.yb-guide-button:focus-visible{background:#0d5596;outline:3px solid rgba(255,204,36,.65);outline-offset:2px}.yb-guide-button--secondary{background:#fff;color:#1268b3}.yb-guide-button--yellow{border-color:#ffcc24;background:#ffcc24;color:#123b67}.yb-guide-button[disabled]{cursor:not-allowed;opacity:.55}
      .yb-location-options{display:grid;gap:12px}.yb-location-option{display:flex;align-items:flex-start;gap:12px;width:100%;padding:16px;border:2px solid #d7e5f2;border-radius:15px;background:#fff;color:#17324d;text-align:left;cursor:pointer}.yb-location-option:hover,.yb-location-option:focus-visible{border-color:#1268b3;background:#f4f9fd;outline:3px solid rgba(255,204,36,.5)}.yb-location-icon{display:grid;flex:0 0 40px;width:40px;height:40px;place-items:center;border-radius:50%;background:#e8f3ff;color:#1268b3;font-size:21px}.yb-location-option strong,.yb-location-option span{display:block}.yb-location-option span{margin-top:3px;color:#5a7085;font-size:14px}
      .yb-guide-status{margin:0 0 16px;padding:12px 14px;border-radius:11px;background:#edf7ef;color:#236533;font-weight:700}.yb-guide-error{background:#fff2ef;color:#943a2e}.yb-map{height:330px;margin-top:13px;border:2px solid #bdd6ea;border-radius:14px;overflow:hidden}.yb-map-help{margin:10px 0 0;color:#50677e;font-size:14px}
      .yb-guide-reopen{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:10px 0 0;padding:10px 12px;border-radius:10px;background:#edf5fc;color:#123b67;font:600 13px/1.3 Arial,sans-serif}.yb-guide-reopen button{padding:3px;border:0;border-bottom:1px solid currentColor;background:transparent;color:#1268b3;font:700 13px/1.2 Arial,sans-serif;cursor:pointer}.yb-guide-confirmed{color:#236533}
      @media(max-width:560px){.yb-guide-overlay{align-items:flex-end;padding:0}.yb-guide-modal{max-height:92dvh;border-radius:22px 22px 0 0}.yb-guide-head{padding:24px 58px 8px 20px}.yb-guide-body{padding:12px 20px max(22px,env(safe-area-inset-bottom))}.yb-guide-cards{grid-template-columns:1fr}.yb-guide-card{display:grid;grid-template-columns:62px 1fr;column-gap:10px;align-items:start}.yb-guide-card svg{grid-row:1/2;width:58px;height:58px}.yb-guide-card .yb-guide-fields{grid-column:1/-1}.yb-guide-actions{flex-direction:column-reverse}.yb-guide-button{width:100%}.yb-map{height:285px}}
      @media(prefers-reduced-motion:no-preference){.yb-guide-overlay{animation:ybFade .16s ease-out}.yb-guide-modal{animation:ybRise .22s ease-out}@keyframes ybFade{from{opacity:0}}@keyframes ybRise{from{transform:translateY(14px);opacity:.7}}}
    `;
    document.head.appendChild(style);
  }

  function createModal({ title, intro = "", content, closeLabel = "Close" }) {
    closeModal();
    lastFocused = document.activeElement;
    const overlay = document.createElement("div");
    overlay.className = "yb-guide-overlay";
    overlay.innerHTML = `
      <section class="yb-guide-modal" role="dialog" aria-modal="true" aria-labelledby="yb-guide-title">
        <button class="yb-guide-close" type="button" data-yb-close aria-label="${closeLabel}">&times;</button>
        <header class="yb-guide-head">
          <h2 id="yb-guide-title">${title}</h2>
          ${intro ? `<p>${intro}</p>` : ""}
        </header>
        <div class="yb-guide-body">${content}</div>
      </section>`;
    overlay.addEventListener("click", (event) => {
      if (event.target === overlay || event.target.closest("[data-yb-close]")) closeModal();
    });
    document.addEventListener("keydown", handleModalKeydown);
    document.body.classList.add("yb-guide-lock");
    document.body.appendChild(overlay);
    activeModal = overlay;
    requestAnimationFrame(() => overlay.querySelector("[data-yb-close]")?.focus());
    return overlay;
  }

  function handleModalKeydown(event) {
    if (!activeModal) return;
    if (event.key === "Escape") {
      event.preventDefault();
      closeModal();
      return;
    }
    if (event.key !== "Tab") return;
    const focusable = [...activeModal.querySelectorAll(
      'button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])',
    )].filter((element) => element.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function closeModal() {
    if (!activeModal) return;
    const wasLocationPrompt =
      !locationConfirmed &&
      !pendingCheckout &&
      activeModal.querySelector(
        "[data-yb-skip-location], [data-yb-current-location], [data-yb-map-location]",
      );
    if (wasLocationPrompt) dismissLocationPrompt();
    activeMap?.remove();
    activeMap = null;
    activeModal.remove();
    activeModal = null;
    document.removeEventListener("keydown", handleModalKeydown);
    document.body.classList.remove("yb-guide-lock");
    if (lastFocused instanceof HTMLElement) lastFocused.focus();
  }

  function openLocationChooser() {
    const modal = createModal({
      title: locationConfirmed ? "Delivery location confirmed" : "Confirm your precise delivery location",
      intro: "Share the exact entrance or handover point. This supports the address you enter at checkout.",
      content: `
        ${locationConfirmed ? '<p class="yb-guide-status">Delivery location confirmed</p>' : ""}
        <div class="yb-location-options">
          <button class="yb-location-option" type="button" data-yb-current-location>
            <span class="yb-location-icon" aria-hidden="true">?</span>
            <span><strong>Use my current location</strong><span>Your browser will ask permission only after you choose this option.</span></span>
          </button>
          <button class="yb-location-option" type="button" data-yb-map-location>
            <span class="yb-location-icon" aria-hidden="true">?</span>
            <span><strong>Choose location on map</strong><span>Place a pin at the entrance or handover point.</span></span>
          </button>
        </div>
        <div class="yb-guide-actions">
          <button class="yb-guide-button yb-guide-button--secondary" type="button" data-yb-skip-location>Continue without location</button>
        </div>`,
    });
    modal.querySelector("[data-yb-current-location]").addEventListener("click", captureCurrentLocation);
    modal.querySelector("[data-yb-map-location]").addEventListener("click", openMapPicker);
    modal.querySelector("[data-yb-skip-location]").addEventListener("click", skipLocationPrompt);
  }

  function captureCurrentLocation() {
    if (!navigator.geolocation) {
      showLocationFallback("Location is not supported by this browser.");
      return;
    }
    setModalStatus("Requesting your location?", false);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        lastKnownCoords = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          accuracy: position.coords.accuracy,
        };
        saveLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          accuracy: position.coords.accuracy,
          source: "CURRENT_LOCATION",
        });
      },
      (error) => {
        const denied = error.code === error.PERMISSION_DENIED;
        showLocationFallback(
          denied
            ? "Location permission was denied. You can try again, choose the point on a map, or continue."
            : "We could not get your current location. You can try again or choose the point on a map.",
        );
      },
      { enableHighAccuracy: true, timeout: 12000, maximumAge: 60000 },
    );
  }

  function setModalStatus(message, isError) {
    const body = activeModal?.querySelector(".yb-guide-body");
    if (!body) return;
    let status = body.querySelector("[data-yb-status]");
    if (!status) {
      status = document.createElement("p");
      status.dataset.ybStatus = "";
      body.prepend(status);
    }
    status.className = `yb-guide-status${isError ? " yb-guide-error" : ""}`;
    status.textContent = message;
  }

  function showLocationFallback(message) {
    const body = activeModal?.querySelector(".yb-guide-body");
    if (!body) return;
    body.innerHTML = `
      <p class="yb-guide-status yb-guide-error" role="alert">${message}</p>
      <div class="yb-location-options">
        <button class="yb-location-option" type="button" data-yb-retry><span class="yb-location-icon" aria-hidden="true">?</span><span><strong>Try again</strong><span>Ask the browser for your current location again.</span></span></button>
        <button class="yb-location-option" type="button" data-yb-map-location><span class="yb-location-icon" aria-hidden="true">?</span><span><strong>Choose on map</strong><span>Place the pin yourself instead.</span></span></button>
      </div>
      <div class="yb-guide-actions"><button class="yb-guide-button yb-guide-button--secondary" type="button" data-yb-skip-location>Continue without location</button></div>`;
    body.querySelector("[data-yb-retry]").addEventListener("click", captureCurrentLocation);
    body.querySelector("[data-yb-map-location]").addEventListener("click", openMapPicker);
    body.querySelector("[data-yb-skip-location]").addEventListener("click", skipLocationPrompt);
  }

  function rememberCoords(lat, lng, accuracy) {
    const latitude = Number(lat);
    const longitude = Number(lng);
    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
    lastKnownCoords = {
      lat: latitude,
      lng: longitude,
      accuracy: accuracy === "" || accuracy == null ? "" : Number(accuracy),
    };
    return lastKnownCoords;
  }

  function readBrowserLocation() {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        resolve(null);
        return;
      }
      navigator.geolocation.getCurrentPosition(
        (position) => resolve(rememberCoords(
          position.coords.latitude,
          position.coords.longitude,
          position.coords.accuracy,
        )),
        () => resolve(null),
        { enableHighAccuracy: true, timeout: 8000, maximumAge: 120000 },
      );
    });
  }

  async function resolveMapCenter() {
    if (lastKnownCoords) {
      return { center: [lastKnownCoords.lat, lastKnownCoords.lng], zoom: 17, fromCustomer: true };
    }
    const live = await readBrowserLocation();
    if (live) return { center: [live.lat, live.lng], zoom: 17, fromCustomer: true };
    return { center: DUBAI_CENTER, zoom: 12, fromCustomer: false };
  }

  async function loadLeaflet() {
    if (window.L) return window.L;
    if (!document.getElementById("yb-leaflet-css")) {
      const link = document.createElement("link");
      link.id = "yb-leaflet-css";
      link.rel = "stylesheet";
      link.href = `https://unpkg.com/leaflet@${LEAFLET_VERSION}/dist/leaflet.css`;
      link.crossOrigin = "";
      document.head.appendChild(link);
    }
    let script = document.getElementById("yb-leaflet-js");
    if (!script) {
      script = document.createElement("script");
      script.id = "yb-leaflet-js";
      script.src = `https://unpkg.com/leaflet@${LEAFLET_VERSION}/dist/leaflet.js`;
      script.crossOrigin = "";
      document.head.appendChild(script);
    }
    if (window.L) return window.L;
    await new Promise((resolve, reject) => {
      if (window.L) {
        resolve();
        return;
      }
      const finish = () => (window.L ? resolve() : reject(new Error("Map library failed to load")));
      script.addEventListener("load", finish, { once: true });
      script.addEventListener("error", () => reject(new Error("Map library failed to load")), { once: true });
      if (script.readyState === "complete" || script.readyState === "loaded") finish();
    });
    return window.L;
  }

  async function openMapPicker() {
    const modal = createModal({
      title: "Choose your delivery point",
      intro: "Tap the map or drag the pin to the exact entrance or handover point.",
      content: `
        <p class="yb-guide-status" data-yb-status>Finding your location?</p>
        <div class="yb-map" data-yb-map aria-label="Interactive delivery location map"></div>
        <p class="yb-map-help">Check that the pin is in the correct area and at a location the delivery partner can access.</p>
        <div class="yb-guide-actions">
          <button class="yb-guide-button yb-guide-button--secondary" type="button" data-yb-map-cancel>Back</button>
          <button class="yb-guide-button yb-guide-button--yellow" type="button" data-yb-map-save disabled>Confirm this location</button>
        </div>`,
    });
    modal.querySelector("[data-yb-map-cancel]").addEventListener("click", openLocationChooser);
    const saveButton = modal.querySelector("[data-yb-map-save]");
    let selected = null;
    try {
      const [{ center, zoom, fromCustomer }, L] = await Promise.all([
        resolveMapCenter(),
        loadLeaflet(),
      ]);
      if (!activeModal || activeModal !== modal) return;
      const mapEl = modal.querySelector("[data-yb-map]");
      activeMap = L.map(mapEl, { zoomControl: true }).setView(center, zoom);
      const tiles = L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      }).addTo(activeMap);
      const marker = L.marker(center, { draggable: true }).addTo(activeMap);
      const select = ({ lat, lng }) => {
        selected = { lat, lng };
        marker.setLatLng(selected);
        saveButton.disabled = false;
        setModalStatus("Pin selected. Confirm when the entrance or handover point is correct.", false);
      };
      select({ lat: center[0], lng: center[1] });
      setModalStatus(
        fromCustomer
          ? "Your current location is marked. Drag the pin to the exact entrance if needed."
          : "Map ready. Tap or drag the pin to your entrance or handover point.",
        false,
      );
      activeMap.on("click", (event) => select(event.latlng));
      marker.on("dragend", () => select(marker.getLatLng()));
      saveButton.addEventListener("click", () => {
        if (selected) saveLocation({ ...selected, accuracy: "", source: "MAP_PIN" });
      });
      const refreshSize = () => activeMap?.invalidateSize();
      tiles.on("load", refreshSize);
      window.setTimeout(refreshSize, 80);
      window.setTimeout(refreshSize, 400);
    } catch (error) {
      setModalStatus("The map could not load. Check your connection, try again, or continue without location.", true);
      saveButton.remove();
      const actions = modal.querySelector(".yb-guide-actions");
      actions.insertAdjacentHTML("beforeend", '<button class="yb-guide-button" type="button" data-yb-map-retry>Try again</button><button class="yb-guide-button yb-guide-button--secondary" type="button" data-yb-map-skip>Continue without location</button>');
      actions.querySelector("[data-yb-map-retry]").addEventListener("click", openMapPicker);
      actions.querySelector("[data-yb-map-skip]").addEventListener("click", skipLocationPrompt);
      console.warn("[YamBaba] Leaflet unavailable", error);
    }
  }

  async function saveLocation({ lat, lng, accuracy, source }) {
    const latitude = Number(lat).toFixed(6);
    const longitude = Number(lng).toFixed(6);
    const mapUrl = `https://www.openstreetmap.org/?mlat=${latitude}&mlon=${longitude}#map=17/${latitude}/${longitude}`;
    setModalStatus("Saving your delivery location?", false);
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          attributes: {
            [ATTRIBUTES.lat]: latitude,
            [ATTRIBUTES.lng]: longitude,
            [ATTRIBUTES.accuracy]: accuracy === "" ? "" : String(Math.round(Number(accuracy))),
            [ATTRIBUTES.capturedAt]: new Date().toISOString(),
            [ATTRIBUTES.source]: source,
            [ATTRIBUTES.mapUrl]: mapUrl,
          },
        }),
      });
      if (!response.ok) throw new Error(`Cart update failed (${response.status})`);
      rememberCoords(latitude, longitude, accuracy);
      locationConfirmed = true;
      refreshReopenLinks();
      showConfirmation();
    } catch (error) {
      setModalStatus("We could not save the location. Please try again, choose the map, or continue without it.", true);
      console.warn("[YamBaba] Delivery location was not saved", error);
    }
  }

  function showConfirmation() {
    const modal = createModal({
      title: "Delivery location confirmed",
      intro: "Your precise delivery point has been saved with this cart.",
      content: `
        <p class="yb-guide-status">Delivery location confirmed</p>
        <p class="yb-map-help">If your entrance or handover point changes, select Change before checkout.</p>
        <div class="yb-guide-actions">
          <button class="yb-guide-button yb-guide-button--secondary" type="button" data-yb-change-location>Change</button>
          <button class="yb-guide-button yb-guide-button--yellow" type="button" data-yb-confirm-continue>${pendingCheckout ? "Continue to checkout" : "Done"}</button>
        </div>`,
    });
    modal.querySelector("[data-yb-change-location]").addEventListener("click", openLocationChooser);
    modal.querySelector("[data-yb-confirm-continue]").addEventListener("click", continueCheckout);
  }

  function continueCheckout() {
    closeModal();
    if (!pendingCheckout) return;
    const destination = pendingCheckout;
    pendingCheckout = null;
    window.location.assign(destination);
  }

  function isTraditionalCheckout(element) {
    if (!element || element.closest(EXCLUDED_CHECKOUT_SELECTOR)) return false;
    const trigger = element.closest(CHECKOUT_SELECTOR);
    if (!trigger || /shop\s*pay|buy\s*it\s*now/i.test(trigger.textContent || trigger.value || "")) return false;
    if (trigger.matches(".previewCartGroup .button:first-child")) {
      const href = trigger.getAttribute("href") || "";
      return !href || /checkout/i.test(href) || /checkout/i.test(trigger.textContent || "");
    }
    return true;
  }

  function interceptCheckout(event) {
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const trigger = event.target instanceof Element ? event.target.closest(CHECKOUT_SELECTOR) : null;
    if (!isTraditionalCheckout(trigger)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    pendingCheckout = trigger.getAttribute("href") || "/checkout";
    if (!locationConfirmed) openLocationChooser();
    else showConfirmation();
  }

  function isCartPage() {
    const path = (window.location.pathname || "").replace(/\/+$/, "") || "/";
    return path === "/cart";
  }

  function isCartDrawerOpen() {
    const drawer = document.getElementById("scoder-cart-sidebar")
      || document.querySelector(".scoder-cart-sidebar");
    if (!drawer) return false;
    if (drawer.classList.contains("open") || drawer.classList.contains("active") || drawer.classList.contains("is-open")) {
      return true;
    }
    const style = window.getComputedStyle(drawer);
    if (style.visibility === "hidden" || style.display === "none") return false;
    const rect = drawer.getBoundingClientRect();
    return rect.width > 40 && rect.right > 20 && rect.left < window.innerWidth;
  }

  function maybeShowLocationPrompt() {
    if (activeModal) return;
    if (!shouldAutoPromptLocation()) return;
    openLocationChooser();
  }

  function scheduleLocationPrompt(delayMs = 280) {
    if (locationPromptScheduled) return;
    if (!shouldAutoPromptLocation()) return;
    locationPromptScheduled = true;
    window.setTimeout(() => {
      locationPromptScheduled = false;
      maybeShowLocationPrompt();
    }, delayMs);
  }

  function handleCartOpenClick(event) {
    if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const trigger = event.target instanceof Element ? event.target.closest(CART_OPEN_SELECTOR) : null;
    if (!trigger) return;
    if (trigger.closest(CHECKOUT_SELECTOR) && isTraditionalCheckout(trigger.closest(CHECKOUT_SELECTOR))) return;
    scheduleLocationPrompt(320);
  }

  function watchCartDrawer() {
    const drawer = document.getElementById("scoder-cart-sidebar")
      || document.querySelector(".scoder-cart-sidebar");
    if (!drawer) return;
    const sync = () => {
      const open = isCartDrawerOpen();
      if (open && !cartDrawerWasOpen) scheduleLocationPrompt(350);
      cartDrawerWasOpen = open;
    };
    sync();
    const observer = new MutationObserver(sync);
    observer.observe(drawer, { attributes: true, attributeFilter: ["class", "style", "aria-hidden"] });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
  }

  function injectReopenLinks() {
    document.querySelectorAll(ACTION_HOST_SELECTOR).forEach((host) => {
      if (host.querySelector(":scope > .yb-guide-reopen")) return;
      const row = document.createElement("div");
      row.className = "yb-guide-reopen";
      row.innerHTML = `
        <span class="${locationConfirmed ? "yb-guide-confirmed" : ""}">${locationConfirmed ? "Delivery location confirmed" : "Help us find the correct entrance"}</span>
        <button type="button" data-yb-reopen>${locationConfirmed ? "Change" : "Set location"}</button>`;
      row.querySelector("[data-yb-reopen]").addEventListener("click", () => openLocationChooser());
      host.appendChild(row);
    });
  }

  function refreshReopenLinks() {
    document.querySelectorAll(".yb-guide-reopen").forEach((row) => row.remove());
    injectReopenLinks();
  }

  async function hydrateLocationState() {
    try {
      const response = await fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } });
      if (!response.ok) return;
      const cart = await response.json();
      if (cart.attributes?.[ATTRIBUTES.lat] && cart.attributes?.[ATTRIBUTES.lng]) {
        rememberCoords(
          cart.attributes[ATTRIBUTES.lat],
          cart.attributes[ATTRIBUTES.lng],
          cart.attributes[ATTRIBUTES.accuracy],
        );
        locationConfirmed = true;
        refreshReopenLinks();
      }
    } catch (error) {
      console.warn("[YamBaba] Cart location state unavailable", error);
    }
  }

  function findFooterMenuList() {
    const headingNodes = Array.from(
      document.querySelectorAll(
        "footer .footer-block__heading, footer h2, footer h3, .footer .footer-block__heading",
      ),
    );
    const preferred =
      headingNodes.find((node) => {
        const text = (node.textContent || "").trim().toLowerCase();
        return text === "customer service";
      }) ||
      headingNodes.find((node) => {
        const text = (node.textContent || "").trim().toLowerCase();
        return text === "information" || text === "menu";
      });
    const column = preferred
      ? preferred.closest(".footer-block__item, .footer-block__column") ||
        preferred.parentElement
      : null;
    return (
      (column && column.querySelector("ul")) ||
      document.querySelector("footer .footer-block__list ul")
    );
  }

  function ensureB2BFooterLink() {
    // Prefer Customer service column; never create a full-width bottom bar.
    document.querySelectorAll(".yb-b2b-footer-block").forEach((node) => node.remove());

    const existingInFooter = document.querySelector(
      "footer a.yb-b2b-footer-link, footer a[href='/pages/b2b-enquiry'], footer a[href*='/pages/b2b-enquiry']",
    );
    if (existingInFooter) return;

    const list = findFooterMenuList();
    if (!list) return;

    const li = document.createElement("li");
    li.className = "yb-b2b-footer-li";
    const link = document.createElement("a");
    link.className = "link link-underline list-menu__item--link yb-b2b-footer-link";
    link.href = "/pages/b2b-enquiry";
    link.innerHTML = '<span class="text">Business / Wholesale Enquiry</span>';
    li.appendChild(link);
    list.appendChild(li);
  }

  function ensureFaqsFooterLink() {
    const existingInFooter = document.querySelector(
      "footer a.yb-faqs-footer-link, footer a[href='/pages/faqs'], footer a[href*='/pages/faqs']",
    );
    if (existingInFooter) return;

    const list = findFooterMenuList();
    if (!list) return;

    const li = document.createElement("li");
    li.className = "yb-faqs-footer-li";
    const link = document.createElement("a");
    link.className =
      "link link-underline list-menu__item--link yb-faqs-footer-link";
    link.href = "/pages/faqs";
    link.innerHTML = '<span class="text">FAQs</span>';
    li.appendChild(link);
    // Prefer FAQs near the top of Customer service links.
    if (list.firstChild) list.insertBefore(li, list.firstChild);
    else list.appendChild(li);
  }

  function ensureBecomePartnerFooterLink() {
    const PARTNER_URL = "https://portal.yambaba.ae/become-a-partner";
    // Do not add "Become a Partner" under Customer service (redundant with yellow CTA).
    // Remove any previously injected Customer-service list link, keep WE ACCEPT CTA only.
    document
      .querySelectorAll(
        "footer .footer-block__list a.yb-partner-footer-link, footer .footer-block__list a[href*='become-a-partner']",
      )
      .forEach((link) => {
        const li = link.closest("li");
        if (li) li.remove();
        else link.remove();
      });

    ensureBecomePartnerFooterCta(PARTNER_URL);
  }

  function partnerCtaHtml() {
    return '<span class="yb-partner-footer-cta__text">Be a Partner</span>';
  }

  function ensureBecomePartnerFooterCta(partnerUrl) {
    const PARTNER_URL =
      partnerUrl || "https://portal.yambaba.ae/become-a-partner";
    const paymentsCol = document.querySelector(
      "footer .yb-footer-payments, .footer .yb-footer-payments",
    );
    if (!paymentsCol) return;

    // Remove any broken CTAs stuck inside the payment icon list
    paymentsCol.querySelectorAll("ul .yb-partner-footer-cta, li .yb-partner-footer-cta").forEach((n) => n.remove());
    paymentsCol.querySelectorAll("a.yb-partner-footer-cta").forEach((n) => {
      if (n.parentElement !== paymentsCol) n.remove();
    });

    let cta = Array.from(paymentsCol.children).find((el) =>
      el.classList?.contains("yb-partner-footer-cta"),
    );
    if (!cta) {
      cta = document.createElement("a");
      cta.className = "yb-partner-footer-cta";
      paymentsCol.appendChild(cta);
    }
    cta.href = PARTNER_URL;
    cta.setAttribute("aria-label", "Be a Partner");
    cta.textContent = "Be a Partner";
  }

  const B2B_BASKET_KEY = "yambaba_b2b_basket_v1";
  const PORTAL_B2B = "https://portal.yambaba.ae/b2b-enquiry";
  // yb-b2b-placement-v3: after Buy it now, full-width bar
  // yb-b2b-cross-domain-v1: sync basket via Domain=.yambaba.ae cookie + URL handoff
  // yb-b2b-clear-dual-cookie-v1: expire host-only AND Domain=.yambaba.ae; empty cookie hides bar

  function parseBasketJson(raw) {
    try {
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  function readAllCookies(name) {
    const values = [];
    const parts = String(document.cookie || "").split(";");
    for (const part of parts) {
      const idx = part.indexOf("=");
      if (idx < 0) continue;
      const k = part.slice(0, idx).trim();
      if (k !== name) continue;
      const raw = part.slice(idx + 1).trim();
      try {
        values.push(decodeURIComponent(raw));
      } catch {
        values.push(raw);
      }
    }
    return values;
  }

  function readCookie(name) {
    const values = readAllCookies(name);
    return values.length ? values[0] : null;
  }

  function writeSharedCookie(name, value) {
    const maxAge = 60 * 60 * 24 * 14;
    const encoded = encodeURIComponent(value);
    document.cookie = `${name}=${encoded}; Path=/; Max-Age=${maxAge}; SameSite=Lax; Secure`;
    document.cookie = `${name}=${encoded}; Domain=.yambaba.ae; Path=/; Max-Age=${maxAge}; SameSite=Lax; Secure`;
  }

  function clearSharedCookie(name) {
    const maxAge = 60 * 60 * 24 * 14;
    const expire = [
      `${name}=; Path=/; Max-Age=0; SameSite=Lax; Secure`,
      `${name}=; Path=/; Max-Age=0`,
      `${name}=; Domain=.yambaba.ae; Path=/; Max-Age=0; SameSite=Lax; Secure`,
      `${name}=; Domain=.yambaba.ae; Path=/; Max-Age=0`,
    ];
    for (const row of expire) document.cookie = row;
    const empty = encodeURIComponent("[]");
    document.cookie = `${name}=${empty}; Path=/; Max-Age=${maxAge}; SameSite=Lax; Secure`;
    document.cookie = `${name}=${empty}; Domain=.yambaba.ae; Path=/; Max-Age=${maxAge}; SameSite=Lax; Secure`;
  }

  function readB2BBasket() {
    const cookieRaws = readAllCookies(B2B_BASKET_KEY);
    if (cookieRaws.length) {
      if (cookieRaws.some((raw) => raw === "[]")) {
        try {
          localStorage.setItem(B2B_BASKET_KEY, "[]");
        } catch {
          /* ignore */
        }
        return [];
      }
      const lists = cookieRaws.map(parseBasketJson);
      return lists.reduce((best, list) => (list.length >= best.length ? list : best), []);
    }
    return parseBasketJson(localStorage.getItem(B2B_BASKET_KEY));
  }

  function writeB2BBasket(items) {
    const clean = Array.isArray(items) ? items : [];
    if (!clean.length) {
      try {
        localStorage.setItem(B2B_BASKET_KEY, "[]");
      } catch {
        /* ignore */
      }
      clearSharedCookie(B2B_BASKET_KEY);
      renderB2BBasketBar();
      return;
    }
    const raw = JSON.stringify(clean);
    try {
      localStorage.setItem(B2B_BASKET_KEY, raw);
    } catch {
      /* ignore quota */
    }
    try {
      writeSharedCookie(B2B_BASKET_KEY, raw);
    } catch {
      /* ignore */
    }
    renderB2BBasketBar();
  }

  function encodeBasketParam(items) {
    try {
      const json = JSON.stringify(items || []);
      return btoa(unescape(encodeURIComponent(json)))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/g, "");
    } catch {
      return "";
    }
  }

  function portalB2BUrl(items) {
    const list = items || readB2BBasket();
    const enc = encodeBasketParam(list);
    return enc ? `${PORTAL_B2B}?b2b=${enc}` : PORTAL_B2B;
  }

  function currentProductMeta() {
    const path = window.location.pathname || "";
    if (!path.includes("/products/")) return null;
    const handle = path.split("/products/")[1]?.split(/[?#]/)[0] || "";
    const title =
      document.querySelector("h1.product__title, h1.product-title, .product__title, [data-product-title]")?.textContent?.trim() ||
      document.querySelector('meta[property="og:title"]')?.getAttribute("content") ||
      document.title;
    const sku =
      document.querySelector("[data-product-sku], .product-sku, .variant-sku, .sku")?.textContent?.replace(/sku:?/i, "").trim() ||
      document.querySelector('input[name="id"]')?.getAttribute("data-sku") ||
      null;
    const shopifyProductId =
      window.meta?.product?.id ||
      document.querySelector("[data-product-id]")?.getAttribute("data-product-id") ||
      null;
    const variantInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]',
    );
    const variantId = variantInput?.value || null;
    const image =
      document.querySelector('meta[property="og:image"]')?.getAttribute("content") ||
      document.querySelector(".product__media img, .product-gallery img, .product-single__photo img")?.getAttribute("src") ||
      null;
    const qtyInput = document.querySelector(
      'form[action*="/cart/add"] input[name="quantity"], .quantity__input, input[name="quantity"]',
    );
    const qty = Math.max(1, Number(qtyInput?.value || 1) || 1);
    if (!handle || !title) return null;
    return {
      key: String(variantId || shopifyProductId || handle),
      title: String(title).trim(),
      sku: sku ? String(sku).trim() : null,
      handle,
      shopifyProductId: shopifyProductId ? String(shopifyProductId) : null,
      variantId: variantId ? String(variantId) : null,
      image: image ? String(image) : null,
      qty,
    };
  }

  function findShareAnchor(atc) {
    const root =
      atc?.closest(
        ".product__info-container, .product-single, .product-detail, .product-info, .product-form, .product",
      ) || document;
    const shareEl =
      root.querySelector(
        '[class*="share" i][href], [class*="share" i] button, button[class*="share" i], a[class*="share" i], [aria-label*="share" i], [title*="Share" i], .share-button, .product-share, .social-sharing',
      ) ||
      root.querySelector(".product-button-share, .btn-share, .js-share");
    if (shareEl) {
      return (
        shareEl.closest(
          ".product-button, .product-form__buttons, .share-button, li, button, a",
        ) || shareEl
      );
    }
    const wishlist = root.querySelector(
      '[class*="wishlist" i], [aria-label*="wishlist" i], .product-wishlist, .btn-wishlist',
    );
    if (wishlist?.parentElement) return wishlist.parentElement;
    return null;
  }

  function findBuyItNowAnchor(root) {
    const buyBtn = Array.from(
      root.querySelectorAll('button, a, input[type="submit"], [role="button"]'),
    ).find((el) => {
      const text = `${el.textContent || ""} ${el.getAttribute("aria-label") || ""} ${el.value || ""}`
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
      return text.includes("buy it now") || text === "buy now";
    });
    if (!buyBtn) return null;
    return (
      buyBtn.closest(
        ".shopify-payment-button, #shopify-payment-button, .payment-buttons, [data-shopify='payment-button']",
      ) || buyBtn
    );
  }

  function findMetaAnchor(root) {
    const skuLabel = Array.from(
      root.querySelectorAll("span, div, p, dt, th, li, label"),
    ).find((el) => {
      const t = (el.textContent || "").trim().toLowerCase();
      return (
        t === "sku" ||
        t.startsWith("sku:") ||
        t === "categories" ||
        t.startsWith("categories") ||
        t === "availability" ||
        t.startsWith("availability") ||
        t === "product type" ||
        t.startsWith("product type")
      );
    });
    if (!skuLabel) return null;
    return (
      skuLabel.closest(
        ".product__info-container > *, .product-meta, .product-info, .product-details, .product__description, .product-single__meta, dl, ul, .product-meta__item, .product-block",
      ) || skuLabel
    );
  }

  function placeB2BBar(wrap) {
    const buybox = document.querySelector(".yb-pdp-buybox");
    if (buybox) {
      if (!buybox.contains(wrap)) buybox.appendChild(wrap);
      return "buybox";
    }
    const info =
      document.querySelector(".yb-pdp-info") ||
      document.querySelector(".yb-pdp-main");
    if (info) {
      if (!info.contains(wrap)) info.appendChild(wrap);
      return "info";
    }

    const scope =
      document.querySelector(
        ".product__info-container, .product-info, .product-single__info, .product-detail, .product-single, .productView-product, .product",
      ) || document;
    const buyBtn = Array.from(
      scope.querySelectorAll('button, a, input[type="submit"], [role="button"]'),
    ).find((el) => {
      const text = `${el.textContent || ""} ${el.getAttribute("aria-label") || ""} ${el.value || ""}`
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
      return text.includes("buy it now") || text === "buy now";
    });
    const metaBlock = findMetaAnchor(scope);

    if (buyBtn) {
      const payment =
        buyBtn.closest(
          ".shopify-payment-button, #shopify-payment-button, .payment-buttons, [data-shopify='payment-button']",
        ) || buyBtn;
      if (payment.nextElementSibling !== wrap) {
        payment.insertAdjacentElement("afterend", wrap);
      }
      return "buy-now";
    }

    if (metaBlock?.parentElement) {
      if (wrap.nextElementSibling !== metaBlock) {
        metaBlock.insertAdjacentElement("beforebegin", wrap);
      }
      return "meta";
    }

    const atc =
      document.querySelector("#product-add-to-cart") ||
      document.querySelector("form[action*='/cart/add'] button.product-form__submit") ||
      document.querySelector("form[action*='/cart/add'] button[name='add']");
    if (atc) {
      const form = atc.closest("form") || atc;
      if (form.nextElementSibling !== wrap) {
        form.insertAdjacentElement("afterend", wrap);
      }
      return "atc-form";
    }
    return "none";
  }

  function showB2BAddedToast() {
    let toast = document.querySelector(".yb-b2b-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "yb-b2b-toast";
      document.body.appendChild(toast);
    }
    toast.innerHTML = `
      <div class="yb-b2b-toast__panel">
        <strong>Added to your B2B enquiry</strong>
        <div class="yb-b2b-toast__actions">
          <button type="button" class="yb-b2b-toast__continue">Continue Shopping</button>
          <a class="yb-b2b-toast__view" href="${portalB2BUrl()}">View B2B Enquiry</a>
        </div>
      </div>
    `;
    toast.hidden = false;
    toast.querySelector(".yb-b2b-toast__continue")?.addEventListener(
      "click",
      () => {
        toast.hidden = true;
      },
      { once: true },
    );
    window.setTimeout(() => {
      if (toast && !toast.hidden) toast.hidden = true;
    }, 8000);
  }

  function ensureProductB2BButton() {
    if (!currentProductMeta()) return;

    let wrap = document.querySelector(".yb-b2b-product-actions");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "yb-b2b-product-actions";
      wrap.setAttribute("data-yb-b2b-bar", "1");
      wrap.innerHTML = `
        <div class="yb-b2b-product-actions__inner">
          <p class="yb-b2b-product-actions__label">B2B Enquiry</p>
          <div class="yb-b2b-product-actions__row">
            <button type="button" class="yb-b2b-add-btn">Add to B2B</button>
            <a class="yb-b2b-open-link" href="${portalB2BUrl()}">B2B Enquiry</a>
          </div>
        </div>
      `;
      wrap.querySelector(".yb-b2b-add-btn")?.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const meta = currentProductMeta();
        if (!meta) return;
        // Never touch Shopify cart ? B2B basket is localStorage only.
        const items = readB2BBasket().filter(
          (i) => !(i.sku && /^YB-DEMO-/i.test(String(i.sku))),
        );
        const idx = items.findIndex(
          (i) =>
            i.key === meta.key ||
            (i.handle && meta.handle && i.handle === meta.handle) ||
            (i.shopifyProductId &&
              meta.shopifyProductId &&
              i.shopifyProductId === meta.shopifyProductId),
        );
        if (idx >= 0) {
          items[idx].qty = Math.max(1, Number(items[idx].qty || 1) + meta.qty);
          items[idx].title = meta.title;
          items[idx].sku = meta.sku;
          items[idx].image = meta.image || items[idx].image || null;
          items[idx].variantId = meta.variantId || items[idx].variantId || null;
        } else {
          items.push(meta);
        }
        writeB2BBasket(items);
        const btn = wrap.querySelector(".yb-b2b-add-btn");
        if (btn) {
          btn.textContent = "Added";
          window.setTimeout(() => {
            btn.textContent = "Add to B2B";
          }, 1400);
        }
        showB2BAddedToast();
      });
    } else {
      const label = wrap.querySelector(".yb-b2b-product-actions__label");
      const addBtn = wrap.querySelector(".yb-b2b-add-btn");
      const openLink = wrap.querySelector(".yb-b2b-open-link");
      if (label) label.textContent = "B2B Enquiry";
      if (addBtn && addBtn.textContent !== "Added") addBtn.textContent = "Add to B2B";
      if (openLink) {
        openLink.textContent = "B2B Enquiry";
        openLink.setAttribute("href", portalB2BUrl());
      }
    }

    placeB2BBar(wrap);
    // Shopify Payment Button often mounts late ? re-seat after Buy it now appears.
    if (!wrap.dataset.ybReseat) {
      wrap.dataset.ybReseat = "1";
      [400, 1200, 2500].forEach((ms) => {
        window.setTimeout(() => placeB2BBar(wrap), ms);
      });
    }
  }

  function scrubDollarCurrencyCopy() {
    // UAE single-store: visible "$123" copy should read AED, not USD.
    // Skip scripts/styles/inputs; only rewrite text nodes.
    const root = document.body;
    if (!root || root.dataset.ybAedScrubbed === "1") return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent) return NodeFilter.FILTER_REJECT;
        const tag = parent.tagName;
        if (
          tag === "SCRIPT" ||
          tag === "STYLE" ||
          tag === "NOSCRIPT" ||
          tag === "TEXTAREA" ||
          tag === "INPUT" ||
          tag === "CODE"
        ) {
          return NodeFilter.FILTER_REJECT;
        }
        if (!node.nodeValue || node.nodeValue.indexOf("$") === -1) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      const next = node.nodeValue
        .replace(/\$\s*(\d[\d,]*(?:\.\d+)?)/g, "AED $1")
        .replace(/AED\s+AED\s+/g, "AED ");
      if (next !== node.nodeValue) node.nodeValue = next;
    }
    root.dataset.ybAedScrubbed = "1";
  }

  function renderB2BBasketBar() {
    const items = readB2BBasket().filter(
      (i) => !(i.sku && /^YB-DEMO-/i.test(String(i.sku))),
    );
    let bar = document.querySelector(".yb-b2b-basket-bar");
    if (!items.length) {
      bar?.remove();
      return;
    }
    if (!bar) {
      bar = document.createElement("div");
      bar.className = "yb-b2b-basket-bar";
      document.body.appendChild(bar);
    }
    const unique = items.length;
    bar.innerHTML = `
      <div class="yb-b2b-basket-bar__inner">
        <span>B2B Enquiry (${unique})</span>
        <a href="${portalB2BUrl()}">View B2B Enquiry</a>
      </div>
    `;
  }

  function initMinimumOrderGuard() {
    const PORTAL = "https://portal.yambaba.ae";
    let settings = { enabled: false, minimumMerchandiseAmount: 0, customerMessage: "" };
    let lastMerchandise = 0;
    fetch(`${PORTAL}/api/storefront-commerce-settings?shop=yambaba-store.myshopify.com`)
      .then((r) => r.json())
      .then((data) => {
        if (data && data.ok) settings = data;
        paintMinOrder();
      })
      .catch(() => {});

    function merchandiseFromCart(cart) {
      if (!cart) return 0;
      if (typeof cart.items_subtotal_price === "number") {
        return cart.items_subtotal_price / 100;
      }
      const items = cart.items || [];
      return items.reduce((sum, item) => {
        const line = Number(item.final_line_price || item.line_price || 0) / 100;
        return sum + line;
      }, 0);
    }

    function productPageMerchandise() {
      const qty = Number(
        document.querySelector('form[action*="/cart/add"] input[name="quantity"]')?.value || 1,
      ) || 1;
      const priceText =
        document.querySelector("[data-product-price], .price-item--regular, .product__price")
          ?.textContent || "";
      const num = Number(String(priceText).replace(/[^\d.]/g, ""));
      return Number.isFinite(num) ? num * qty : lastMerchandise;
    }

    function remainingMessage(merchandise) {
      const min = Number(settings.minimumMerchandiseAmount) || 0;
      const remain = Math.max(0, Math.round((min - merchandise) * 100) / 100);
      const base = settings.customerMessage || `Minimum order value is AED ${min}`;
      return remain > 0
        ? `${base} Add AED ${remain.toFixed(2)} more to continue to checkout.`
        : base;
    }

    function isBlocked(amount) {
      if (!settings.enabled) return false;
      const min = Number(settings.minimumMerchandiseAmount) || 0;
      return amount + 1e-9 < min;
    }

    function paintMinOrder() {
      if (!settings.enabled) return;
      fetch("/cart.js")
        .then((r) => r.json())
        .then((cart) => {
          lastMerchandise = merchandiseFromCart(cart);
          const blocked = isBlocked(lastMerchandise);
          document.querySelectorAll(".yb-min-order-banner").forEach((n) => n.remove());
          if (!blocked) return;
          const banner = document.createElement("div");
          banner.className = "yb-min-order-banner";
          banner.style.cssText =
            "margin:10px 0;padding:12px 14px;border-radius:12px;background:#EAF4FF;color:#004A9F;font:600 14px/1.45 Arial,sans-serif;border:1px solid #9ec5ea";
          banner.textContent = remainingMessage(lastMerchandise);
          document
            .querySelectorAll(
              ".previewCartGroup, .cart__footer, .scoder-cart-sidebar .cart__footer, form[action*='/cart']",
            )
            .forEach((host) => host.prepend(banner.cloneNode(true)));
          document
            .querySelectorAll(
              'a[href^="/checkout"], button[name="checkout"], input[name="checkout"], [data-cart-checkout], .previewCartGroup .button',
            )
            .forEach((el) => {
              el.setAttribute("aria-disabled", "true");
              el.style.opacity = "0.45";
              el.style.pointerEvents = "none";
            });
        })
        .catch(() => {});
    }

    document.addEventListener(
      "click",
      (event) => {
        if (!settings.enabled) return;
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const buyNow = target.closest(
          ".shopify-payment-button, [aria-label*='Buy it now']",
        );
        const checkout = target.closest(
          'a[href^="/checkout"], button[name="checkout"], input[name="checkout"], [data-cart-checkout]',
        );
        if (!buyNow && !checkout) return;
        const amount = buyNow ? productPageMerchandise() : lastMerchandise;
        if (!isBlocked(amount)) return;
        event.preventDefault();
        event.stopPropagation();
        window.alert(remainingMessage(amount));
      },
      true,
    );
    document.addEventListener("cart:updated", paintMinOrder);
    window.setInterval(paintMinOrder, 4000);
  }

  function init() {
    installStyles();
    ensureB2BFooterLink();
    ensureFaqsFooterLink();
    ensureBecomePartnerFooterLink();
    ensureProductB2BButton();
    scrubDollarCurrencyCopy();
    renderB2BBasketBar();
    window.addEventListener("pageshow", renderB2BBasketBar);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") renderB2BBasketBar();
    });
    window.addEventListener("focus", renderB2BBasketBar);
    document.addEventListener("click", interceptCheckout, true);
    document.addEventListener("click", handleCartOpenClick, true);
    injectReopenLinks();
    const observer = new MutationObserver(() => {
      if (injectScheduled) return;
      injectScheduled = true;
      window.setTimeout(() => {
        injectScheduled = false;
        injectReopenLinks();
        ensureB2BFooterLink();
    ensureFaqsFooterLink();
    ensureBecomePartnerFooterLink();
        ensureProductB2BButton();
        scrubDollarCurrencyCopy();
        if (isCartDrawerOpen() && !cartDrawerWasOpen) scheduleLocationPrompt(200);
        cartDrawerWasOpen = isCartDrawerOpen();
      }, 80);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    watchCartDrawer();
    hydrateLocationState().finally(() => {
      if (isCartPage()) scheduleLocationPrompt(450);
      else if (isCartDrawerOpen()) scheduleLocationPrompt(450);
    });
    initMinimumOrderGuard();
  }

  window.YamBabaCheckoutGuide = {
    open: openLocationChooser,
    changeLocation: openLocationChooser,
  };
  window.YamBabaCheckoutGuideBuild = CHECKOUT_GUIDE_BUILD;

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();
})();

(function moveYamBabaFooterPayments() {
  function move() {
    var existing = document.querySelector(".yb-footer-payments");
    if (existing) {
      appendPartnerCta(existing);
      return;
    }
    var row = document.querySelector("footer .footer-row, .footer .footer-row");
    if (!row) return;
    var source =
      document.querySelector(".footer-bottom .footer__payment") ||
      document.querySelector(".footer-bottom .list-payment") ||
      document.querySelector(".footer-bottom .payment");
    if (!source) return;
    var list = source.matches("ul")
      ? source
      : source.querySelector("ul.list-payment, ul");
    if (!list || !list.querySelector("li")) return;
    var col = document.createElement("div");
    col.className = "footer-block__item footer-block__column yb-footer-payments";
    var heading = document.createElement("h3");
    heading.className = "footer-block__heading";
    heading.textContent = "We accept";
    col.appendChild(heading);
    col.appendChild(list);
    row.appendChild(col);
    var wrap = source.closest(".payment") || source;
    wrap.classList.add("yb-payment-moved");
    appendPartnerCta(col);
  }

  function appendPartnerCta(col) {
    if (!col) return;
    // Never leave a CTA inside the payment icons list
    col.querySelectorAll("ul .yb-partner-footer-cta, li .yb-partner-footer-cta").forEach(function (n) {
      n.remove();
    });
    var cta = null;
    for (var i = 0; i < col.children.length; i++) {
      if (col.children[i].classList && col.children[i].classList.contains("yb-partner-footer-cta")) {
        cta = col.children[i];
        break;
      }
    }
    if (!cta) {
      cta = document.createElement("a");
      cta.className = "yb-partner-footer-cta";
      col.appendChild(cta);
    }
    cta.href = "https://portal.yambaba.ae/become-a-partner";
    cta.setAttribute("aria-label", "Be a Partner");
    cta.textContent = "Be a Partner";
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", move, { once: true });
  } else {
    move();
  }
  setTimeout(move, 400);
  setTimeout(move, 1200);
})();

(function sleekYamBabaTrustBar() {
  function mark() {
    const nodes = Array.from(
      document.querySelectorAll(
        "h3, h4, h5, .title, .icon-box__title, .icon-title, strong, p",
      ),
    );
    const hit = nodes.find((n) =>
      /secure payment/i.test((n.textContent || "").trim()),
    );
    if (!hit) return;
    const section =
      hit.closest(".shopify-section") ||
      hit.closest("section") ||
      hit.closest(".container")?.parentElement;
    if (section) section.classList.add("yb-trust-bar");
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mark, { once: true });
  } else {
    mark();
  }
  setTimeout(mark, 500);
})();

(function loadYamBabaProductPage() {
  if (!/\/products\//i.test(location.pathname)) return;
  // Theme layout already loads product-page.js — never inject a second copy
  // and never fall back to portal.yambaba.ae assets.
  if (window.YamBabaProductPageVersion) return;
  if (document.querySelector('script[src*="yambaba-product-page.js"]')) return;
  var TARGET =
    (window.__YB_THEME_ASSETS__ && window.__YB_THEME_ASSETS__.product) || null;
  if (!TARGET) return;
  var s = document.createElement("script");
  s.src = TARGET;
  s.defer = true;
  document.head.appendChild(s);
})();

/* Inline PDP 3-col + content rescue (survives stale product-page.js cache)
   Target: gallery | info | sticky buybox; shipping/returns park under stack */
(function ybPdpThreeColInline() {
  if (!/\/products\//i.test(location.pathname)) return;

  // Immediate share containment (theme keeps a 300px fallback panel in-flow).
  (function injectShareContainEarly() {
    if (document.getElementById("yb-pdp-share-contain")) return;
    var style = document.createElement("style");
    style.id = "yb-pdp-share-contain";
    style.textContent =
      ".productView .yb-pdp-buybox,.productView-top > .yb-pdp-buybox{" +
      "overflow:visible!important;padding-right:20px!important;box-sizing:border-box!important}" +
      ".productView .yb-pdp-buybox share-button.share-button," +
      ".productView .yb-pdp-buybox .share-button," +
      ".productView .yb-pdp-buybox .productView-share," +
      ".productView .yb-pdp-buybox .scoder-socialShare{" +
      "position:relative!important;display:inline-flex!important;align-items:center!important;" +
      "justify-content:center!important;flex:0 0 36px!important;width:36px!important;" +
      "min-width:36px!important;max-width:36px!important;height:36px!important;" +
      "margin:0!important;right:0!important;left:auto!important;float:none!important;" +
      "overflow:visible!important;box-sizing:border-box!important}" +
      ".productView .yb-pdp-buybox .share-button .share-content{" +
      "position:relative!important;width:36px!important;min-width:36px!important;" +
      "max-width:36px!important;height:36px!important;overflow:visible!important}" +
      ".productView .yb-pdp-buybox .share-button .share-button__button{" +
      "width:36px!important;height:36px!important;min-width:36px!important;padding:0!important}" +
      ".productView .yb-pdp-buybox .share-button .share-button__fallback{" +
      "position:absolute!important;top:calc(100% + 8px)!important;right:0!important;" +
      "left:auto!important;width:min(280px,calc(100vw - 48px))!important;" +
      "max-width:280px!important;z-index:40!important;box-sizing:border-box!important}" +
      ".productView .yb-pdp-buybox .productView-groupTop," +
      ".productView .yb-pdp-buybox .pvGroup-row," +
      ".productView .yb-pdp-buybox .product-form__buttons," +
      ".productView .yb-pdp-buybox .productView-action{" +
      "display:flex!important;flex-wrap:nowrap!important;align-items:center!important;" +
      "gap:6px!important;max-width:100%!important;min-width:0!important;width:100%!important;" +
      "overflow:visible!important;box-sizing:border-box!important}" +
      ".productView .yb-pdp-buybox .productView-buttons{" +
      "display:block!important;max-width:100%!important;overflow:visible!important}" +
      ".productView .yb-pdp-buybox #product-add-to-cart," +
      ".productView .yb-pdp-buybox button[name='add']," +
      ".productView .yb-pdp-buybox .product-form__submit{" +
      "flex:1 1 auto!important;min-width:0!important;max-width:100%!important}" +
      ".productView .yb-pdp-buybox .productView-price," +
      ".productView .yb-pdp-buybox .productView-price *," +
      ".productView .yb-pdp-buybox [class*='subtotal' i]," +
      ".productView .yb-pdp-buybox [class*='subtotal' i] *{color:#004A9F!important}" +
      /* Mobile: lock final layout from first paint */
      "@media (max-width:767px){" +
      ".productView-thumbnail-wrapper,.productView-thumbnail-wrapper.is-hidden-mobile," +
      ".productView-images .productView-for," +
      ".yb-pdp-gallery-polish .productView-thumbnail-wrapper," +
      ".yb-pdp-gallery-polish .productView-thumbnail-wrapper.is-hidden-mobile," +
      ".yb-pdp-gallery-polish .productView-for{" +
      "display:block!important;visibility:visible!important;height:auto!important;margin:8px 0 0!important;padding:0!important;overflow-x:auto!important;overflow-y:visible!important;opacity:1!important}" +
      ".yb-pdp-gallery-polish .productView-thumbnail,.yb-pdp-gallery-polish .productView-thumbnail-link," +
      ".yb-pdp-gallery-polish .productView-for.slick-initialized .slick-slide{" +
      "width:56px!important;min-width:56px!important;max-width:56px!important;height:56px!important;display:block!important}" +
      ".yb-pdp-gallery-polish .productView-thumbnail-link img{width:100%!important;height:100%!important;object-fit:cover!important}" +
      ".productView-moreItem:has(.product-customInformation),.product-customInformation," +
      ".yb-pdp-native-policy,.yb-pdp-policy,.yb-pdp-policy--wide{display:none!important}" +
      ".productView-top,.productView-top.yb-pdp-3col-row{display:block!important}" +
      "}";
    (document.head || document.documentElement).appendChild(style);
  })();

  function ensureCss() {
    if (document.getElementById("yb-pdp-cols-inline")) return;
    var s = document.createElement("style");
    s.id = "yb-pdp-cols-inline";
    s.textContent =
      "@media screen and (min-width:1100px){" +
      ".productView-top.yb-pdp-3col-row{display:grid!important;grid-template-columns:minmax(0,40%) minmax(0,23%) minmax(0,37%)!important;column-gap:0!important;align-items:start!important;width:100%!important;overflow-x:hidden!important}" +
      ".productView-top.yb-pdp-3col-row>.productView-images,.productView-top.yb-pdp-3col-row>.yb-pdp-gallery{grid-column:1!important;width:100%!important;float:none!important;min-width:0!important;padding:0 20px 8px 0!important}" +
      ".productView-top.yb-pdp-3col-row>.yb-pdp-info,.productView-top.yb-pdp-3col-row>.yb-pdp-main.yb-pdp-info{grid-column:2!important;min-width:0!important;padding:0 8px 8px 12px!important;border:0!important;border-left:1px solid #d7e3f2!important;box-shadow:none!important;background:transparent!important;position:static!important}" +
      ".productView-top.yb-pdp-3col-row>.yb-pdp-buybox{grid-column:3!important;min-width:0!important;padding:0 12px 8px 12px!important;border:0!important;border-left:1px solid #d7e3f2!important;border-radius:0!important;background:transparent!important;position:sticky!important;top:88px!important;overflow:visible!important;box-sizing:border-box!important}" +
      ".productView .yb-pdp-buybox share-button.share-button,.productView .yb-pdp-buybox .share-button,.productView .yb-pdp-buybox .productView-share{position:relative!important;display:inline-flex!important;flex:0 0 36px!important;width:36px!important;min-width:36px!important;max-width:36px!important;height:36px!important;margin:0!important;overflow:visible!important}" +
      ".productView .yb-pdp-buybox .share-button .share-content{position:relative!important;width:36px!important;min-width:36px!important;max-width:36px!important;height:36px!important;overflow:visible!important}" +
      ".productView .yb-pdp-buybox .share-button .share-button__fallback{position:absolute!important;top:calc(100% + 8px)!important;right:0!important;left:auto!important;width:min(280px,calc(100vw - 48px))!important;max-width:280px!important;z-index:40!important}" +
      ".productView .yb-pdp-buybox .productView-groupTop,.productView .yb-pdp-buybox .pvGroup-row,.productView .yb-pdp-buybox .product-form__buttons{display:flex!important;flex-wrap:nowrap!important;align-items:center!important;gap:6px!important;max-width:100%!important;min-width:0!important;width:100%!important;overflow:visible!important}" +
      ".productView-top.yb-pdp-3col-row>.yb-pdp-aside,.productView-top.yb-pdp-3col-row>.yb-pdp-facts:not(.yb-pdp-buybox){display:none!important}" +
      ".productView-top.yb-pdp-3col-row>.productView-details.yb-pdp-details-shell{display:none!important}" +
      ".productView.yb-pdp-3col .yb-pdp-stack{display:flex!important;visibility:visible!important;opacity:1!important}" +
      ".yb-pdp-policy-park,.yb-pdp-native-policy{display:none!important}" +
      ".productView.yb-pdp-3col .yb-pdp-buybox .yb-b2b-product-actions{display:block!important;width:100%!important;margin-top:10px!important}" +
      ".productView.yb-pdp-3col .yb-pdp-buybox .productView-price,.productView.yb-pdp-3col .yb-pdp-buybox .productView-price *,.productView.yb-pdp-3col .yb-pdp-buybox .price-item,.productView.yb-pdp-3col .yb-pdp-buybox [class*='subtotal' i]{color:#004A9F!important;font-weight:800!important}" +
      ".productView.yb-pdp-3col .yb-pdp-buybox #product-add-to-cart,.productView.yb-pdp-3col .yb-pdp-buybox button[name='add'],.productView.yb-pdp-3col .yb-pdp-buybox .product-form__submit{max-width:100%!important;background:#004A9F!important;border-color:#004A9F!important;color:#fff!important;font-weight:700!important;text-transform:uppercase!important;border-radius:4px!important}" +
      ".productView.yb-pdp-3col .yb-pdp-buybox .shopify-payment-button__button,.productView.yb-pdp-3col .yb-pdp-buybox .shopify-payment-button button{background:transparent!important;border:0!important;color:#004A9F!important;text-decoration:underline!important;box-shadow:none!important;width:auto!important}" +
      "}";
    document.head.appendChild(s);
  }

  function isPolicyBlock(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.classList && (el.classList.contains("yb-pdp-policy") || el.classList.contains("yb-pdp-policy-park")))
      return true;
    var heading = (
      (el.querySelector("h2, h3, h4, .accordion__title, .productView-label") || {})
        .textContent || ""
    )
      .trim()
      .toLowerCase();
    if (/(shipping|delivery|returns?|refund)/.test(heading)) return true;
    var start = (el.textContent || "").trim().slice(0, 80).toLowerCase();
    return /^(shipping|delivery|returns?|refund)\b/.test(start);
  }

  function isPriceBlock(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.matches && el.matches(".productView-price, .price, .price__container, [data-product-price]"))
      return true;
    return !!(
      el.querySelector &&
      el.querySelector(".productView-price, .price-item, .price__container, [data-product-price]")
    ) && !isBuyBlock(el);
  }

  function isBuyBlock(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.classList && el.classList.contains("yb-b2b-product-actions")) return false;
    if (
      el.querySelector(
        "form[action*='/cart/add'], .productView-buttons, .productView-form, .product-form, [name='add'], .shopify-payment-button, #product-add-to-cart",
      )
    )
      return true;
    var text = (el.textContent || "").toLowerCase();
    return (
      /add to cart|buy it now|buy now/.test(text) &&
      !!el.querySelector("button, input[type='submit']")
    );
  }

  function columnTarget(el) {
    if (el && el.classList && el.classList.contains("yb-b2b-product-actions")) return "buy";
    if (el && el.classList && el.classList.contains("yambaba-seller-fulfillment")) return "buy";
    if (el && el.classList && el.classList.contains("yb-buybox-chrome")) return "buy";
    if (el && el.classList && el.classList.contains("yb-buybox-warranty")) return "buy";
    if (el && el.classList && el.classList.contains("yb-price-vat")) return "buy";
    if (isPolicyBlock(el)) return "policy";
    if (isBuyBlock(el) || isPriceBlock(el)) return "buy";
    return "info";
  }

  function parkPolicy(el) {
    if (!el) return;
    el.classList.add("yb-pdp-hidden", "yb-pdp-native-policy");
    el.setAttribute("hidden", "");
    el.style.setProperty("display", "none", "important");
  }

  function rescue() {
    var info =
      document.querySelector(".yb-pdp-info") ||
      document.querySelector(".yb-pdp-main.yb-pdp-info") ||
      document.querySelector(".yb-pdp-main");
    var buybox = document.querySelector(".yb-pdp-buybox");
    var shell = document.querySelector(".yb-pdp-details-shell");
    var view = document.querySelector(".productView");
    if (!info || !buybox || !view) return;

    if (shell) {
      shell
        .querySelectorAll(
          ".productView-moreItem, .productView-buttons, .productView-form, form[action*='/cart/add'], .shopify-payment-button, .productView-price, .productView-product > *",
        )
        .forEach(function (el) {
          if (info.contains(el) || buybox.contains(el)) return;
          var t = columnTarget(el);
          if (t === "policy") {
            parkPolicy(el);
            return;
          }
          var wrap =
            el.closest(".yb-pdp-details-shell .productView-moreItem") ||
            (el.classList && el.classList.contains("productView-moreItem") ? el : null);
          var node = wrap && !info.contains(wrap) && !buybox.contains(wrap) ? wrap : el;
          if (t === "buy") buybox.appendChild(node);
          else info.appendChild(node);
        });
    }

    Array.prototype.slice.call(info.children).forEach(function (el) {
      var t = columnTarget(el);
      if (t === "buy") buybox.appendChild(el);
      else if (t === "policy") parkPolicy(el);
    });
    Array.prototype.slice.call(buybox.children).forEach(function (el) {
      var t = columnTarget(el);
      if (t === "info" && !(el.classList && (el.classList.contains("yb-pdp-buybox-chrome") || el.classList.contains("yb-buybox-chrome"))))
        info.appendChild(el);
      else if (t === "policy") parkPolicy(el);
    });

    document.querySelectorAll(".yb-b2b-product-actions").forEach(function (el) {
      if (el.closest(".yb-b2b-basket-bar")) return;
      if (!buybox.contains(el)) buybox.appendChild(el);
    });

    // Keep share circle inside the buy column: theme fallback panel is 300px in-flow.
    buybox.style.setProperty("overflow", "visible", "important");
    buybox.style.setProperty("padding-right", "20px", "important");
    buybox
      .querySelectorAll("share-button.share-button, .share-button, .productView-share")
      .forEach(function (share) {
        share.style.setProperty("position", "relative", "important");
        share.style.setProperty("display", "inline-flex", "important");
        share.style.setProperty("flex", "0 0 36px", "important");
        share.style.setProperty("width", "36px", "important");
        share.style.setProperty("min-width", "36px", "important");
        share.style.setProperty("max-width", "36px", "important");
        share.style.setProperty("height", "36px", "important");
        share.style.setProperty("overflow", "visible", "important");
        var content = share.querySelector(".share-content");
        if (content) {
          content.style.setProperty("width", "36px", "important");
          content.style.setProperty("max-width", "36px", "important");
          content.style.setProperty("overflow", "visible", "important");
        }
        share.querySelectorAll(".share-button__fallback").forEach(function (panel) {
          panel.style.setProperty("position", "absolute", "important");
          panel.style.setProperty("top", "calc(100% + 8px)", "important");
          panel.style.setProperty("right", "0", "important");
          panel.style.setProperty("left", "auto", "important");
          panel.style.setProperty("width", "min(280px, calc(100vw - 48px))", "important");
          panel.style.setProperty("max-width", "280px", "important");
          panel.style.setProperty("z-index", "40", "important");
        });
      });

    document.querySelectorAll(".yb-pdp-policy-park").forEach(function (el) {
      el.style.setProperty("display", "none", "important");
    });

    var stack = document.querySelector(".yb-pdp-stack");
    if (stack) {
      if (stack.closest(".yb-pdp-details-shell") || stack.closest(".yb-pdp-info") || stack.closest(".yb-pdp-buybox")) {
        var bottom =
          view.querySelector(".productView-bottom") ||
          view.querySelector(".productView-description") ||
          view;
        if (bottom && stack.parentElement !== bottom) {
          bottom.insertAdjacentElement("afterbegin", stack);
        }
      }
      stack.style.display = "";
      stack.style.visibility = "visible";
      stack.removeAttribute("hidden");
    }
  }

  function arrange() {
    if (window.matchMedia && !window.matchMedia("(min-width: 1100px)").matches) return;
    if (typeof window.__ybArrangePdpThreeColumn === "function") {
      try {
        window.__ybArrangePdpThreeColumn();
      } catch (e) {}
      rescue();
      return;
    }
    var view = document.querySelector(
      ".productView.scoder-productView, .productView.layout-3, .productView",
    );
    if (!view) return;
    if (!view.classList.contains("yb-pdp-colv3-ready")) {
      var row = view.querySelector(".productView-top") || view;
      var gallery = row.querySelector(".productView-images");
      var details = row.querySelector(".productView-details");
      var product = view.querySelector(".productView-product");
      if (!gallery || !product) return;

      var oldAside = row.querySelector(".yb-pdp-aside, .yb-pdp-facts:not(.yb-pdp-buybox)");
      var info = document.createElement("div");
      info.className = "yb-pdp-main yb-pdp-info";
      var buybox = document.createElement("div");
      buybox.className = "yb-pdp-buybox";

      Array.prototype.slice.call(product.children).forEach(function (child) {
        var t = columnTarget(child);
        if (t === "policy") parkPolicy(child);
        else if (t === "buy") buybox.appendChild(child);
        else info.appendChild(child);
      });

      if (oldAside) {
        Array.prototype.slice.call(oldAside.children).forEach(function (child) {
          var t = columnTarget(child);
          if (t === "policy") parkPolicy(child);
          else if (t === "buy") buybox.appendChild(child);
          else info.appendChild(child);
        });
        oldAside.remove();
      }

      gallery.classList.add("yb-pdp-gallery");
      gallery.insertAdjacentElement("afterend", info);
      info.insertAdjacentElement("afterend", buybox);
      if (details) details.classList.add("yb-pdp-details-shell");
      row.classList.add("yb-pdp-3col-row");
      view.classList.add("yb-pdp-3col", "yb-pdp-3col-ready", "yb-pdp-colv3-ready");
    }
    ensureCss();
    rescue();
  }

  function run() {
    try {
      arrange();
    } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  setTimeout(run, 400);
  setTimeout(run, 1200);
  setTimeout(run, 2400);
  setTimeout(run, 4000);
  window.addEventListener("yb:pdp-3col-ready", function () {
    rescue();
  });
})();

/* Load cart-page JS everywhere if theme liquid did not already include it. */
(function loadYamBabaCartPage() {
  var tries = 0;
  var maxTries = 8;

  function ensureCss() {
    if (document.querySelector('link[href*="yambaba-ui-polish.css"]')) return;
    var wantCss =
      (window.__YB_THEME_ASSETS__ && window.__YB_THEME_ASSETS__.polish) || null;
    if (!wantCss) return;
    var l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = wantCss;
    l.media = "all";
    (document.head || document.documentElement).appendChild(l);
  }

  function ensure() {
    tries += 1;
    try {
      ensureCss();
      if (document.querySelector('script[src*="yambaba-cart-page.js"]')) return;
      var wantJs =
        (window.__YB_THEME_ASSETS__ && window.__YB_THEME_ASSETS__.cart) || null;
      if (!wantJs) return;
      var s = document.createElement("script");
      s.src = wantJs;
      s.defer = true;
      (document.head || document.documentElement).appendChild(s);
    } catch (e) {}
    if (tries < maxTries) {
      window.setTimeout(ensure, tries < 4 ? 250 : 500);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ensure);
  } else {
    ensure();
  }
  window.setTimeout(ensure, 0);
})();
